export default __webpack_public_path__ + "static/media/plus.e9799d5c.png";